<!-- 조직관리 > 회원관리 리스트 -->
<template>
  <Loading v-if="isLoading" />
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="sort-group">
        <div class="sort-row">
          <div class="wl">
            <div class="txt-total">Total: {{ totalCnt }}</div>
            <c-InputSearch :placeholder="t('message.searchMultiPlaceholder')" v-model="inputSearch" @search-word="onClickSearch"/>
          </div>
        </div>
        <div class="sort-row">
          <div class="wl">
            <c-btnLine01 :btnText="t('message.selectDownload')" @click.stop="excelDownload('check')"/>
            <c-btnLine01 :btnText="t('message.fullDownload')" @click.stop="excelDownload('all')"/>
          </div>
          <div class="wr">
            <c-btnMenu01 v-bind="btnExcelUpload" @on-click-child="onClickChild"/>
            <c-btn01 :btnText="t('message.individualRegistration')" @click="onClickViewPage2"/>
            <input type="file" :ref="el => { excelFile = el }" :accept="'*'" @change="excelUpload" hidden/>
          </div>
        </div>
      </div>
      <!-- v-data-table 가져옴-->
      <div class="tbl-group size-custom2">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          :items-per-page-options="footerOptions"
          return-object
          show-select
          @click:row="onClickViewPage2"
          :no-data-text="t('message.noRegisteredMembers')"
        >
          <template v-slot:item.idx="{ index }">
            {{ index + 1 }}
          </template>
          <template v-slot:item.regDate="{ item }" >
            <div class="ell01">
              {{ dayjs(item.regDate).format('YYYY-MM-DD') == 'Invalid Date' ? '' : dayjs(item.regDate).format('YYYY-MM-DD HH:mm:ss') }}
            </div>
          </template>
        </v-data-table>
      </div>
      <div class="bottom-btn-group">
        <div class="wl"></div>
        <div class="wr">
          <c-btnLine01 :btnText="t('message.selectDelete')" @click.stop="deleteItems()"/>
        </div>
      </div>
    </div>
  </div>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> <span :style="{ whiteSpace: 'pre-line' }">{{ snackText }}</span> </v-snackbar>
</template>
<style lang="scss" >
</style>
<script setup lang="ts">
import {ref, onMounted, computed} from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import MemberService from "@/services/member.service";
import CompanyService from "@/services/company.service";
import utils from "@/common/Utils";
import * as XLSX from 'xlsx'
import _ from 'lodash';
import dayjs from "dayjs";
import {useRoute} from "vue-router";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//ui
const btnExcelUpload = {
  btnText: t('message.excelRegistration'),
  setItems: [
    //{ title: t('message.departmentCode') },
    { title: t('message.sample') },
    { title: t('message.upload') }
  ],
}

//bind
const isLoading = ref(false)
const excelFile = ref()
const snackbar = ref(false)
const snackText = ref('')
const totalCnt = ref(0)
const inputSearch = ref(null)
const selected = ref([])
const headers = computed(() =>([
  { title: t('message.orderNumber'), key: 'idx' },
  { title: t('message.id'), key: 'memberId' },
  { title: t('message.name'), key: 'memberName'},
  { title: t('message.department'), key: 'deptName' },
  { title: t('message.position'), key: 'posName'},
  { title: t('message.shiftWork'), key: 'shiftYn' },
  { title: t('message.registrationDate'), key: 'regDate' },
  { title: t('message.isActive'), key: 'useYn' },
]))
const items = ref([])
const footerOptions = [
  { value: 5, title: '5' },
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
]

//hook
onMounted(() => {
  onClickSearch('')
})

//function
const onClickSearch=(word)=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    keyword: word,
    companyIdx:companyIdx
  }
  MemberService.getMemberList(params).then(
    (response) => {
      items.value = response.result
      totalCnt.value = response.result.length
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const deleteItems=()=>{
  if(import.meta.env.MODE == 'development') {
    selected.value.forEach((item)=>{
      const idx = items.value.findIndex((tempItem)=> {return tempItem.idx === item.idx})
      if (idx > -1) items.value.splice(idx, 1)
    })

    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let deleteArr = []
    selected.value.forEach( (item)=>{
      deleteArr.push(item.idx)
    })
    let params = {
      companyIdx:companyIdx,
      memberArr: deleteArr,
    }

    MemberService.deleteMember(params).then(
      (response) => {
        if(response.success) {
          selected.value.forEach((item)=>{
            const idx = items.value.findIndex((tempItem)=> {return tempItem.idx === item.idx})
            if (idx > -1) items.value.splice(idx, 1)
          })

          snackText.value = 'success'
          snackbar.value = true
        }
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const onClickViewPage2=(event, row)=>{
  if(row)
    utils.movePage('/organizationalManagement/2/view/'+row.item.idx)
  else
    utils.movePage('/organizationalManagement/2/view/')
}

const onClickChild=(item)=>{
  if(item == t('message.departmentCode')){
    excelDownload('dept')
  }
  else if(item == t('message.sample')){
    excelDownload('sample')
  }
  else if(item == t('message.upload')){
    excelFile.value.click()
  }
}

/**
 for (var i = 0; i < excelData.length; i++) {
  만약 payload에 필요없는 내용이 있다면
   delete excelData[i].칼럼명
  내용이 비어있으면 엑셀파일로 출력 시 빈 칸도 없이 아예 사라짐. 따라서 내용이 없는데 칼럼과 빈 칸이 필요한 경우 추가함
   if (excelData[i].description === null) {
          excelData[i].description = []
          excelData[i].description.push(' ')
        }
}
 */
const excelDownload=async(type)=>{
  if(type=='sample'){
    const response = await fetch(utils.getBaseUrl('sample', 'member_sample.xlsx')); // 서버 파일 경로
    const blob = await response.blob(); // 응답을 Blob 객체로 변환
    const url = window.URL.createObjectURL(blob); // Blob을 URL로 변환

    const a = document.createElement('a'); // `<a>` 태그 동적 생성
    a.href = url;
    a.download = 'member_sample.xlsx'; // 저장할 파일명
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url); // URL 해제
  }
  else if(type=='dept'){
    try{
      let companyIdx = localStorage.getItem('companyIdx')
      let params = {idx: 0, companyIdx: companyIdx}
      const response = await CompanyService.getCompanyTreeList(params)
      let deptList = _.filter(response.result, {treeType:'dept'})
      let posList = _.filter(response.result, {treeType:'pos'})
      let deptData = JSON.parse(JSON.stringify(deptList))
      let posData = JSON.parse(JSON.stringify(posList))

      const wb = XLSX.utils.book_new()
      const deptDataWS = XLSX.utils.json_to_sheet(utils.renameKeys(mapping, deptData))
      XLSX.utils.book_append_sheet(wb, deptDataWS, t('message.department'))
      const posDataWS = XLSX.utils.json_to_sheet(utils.renameKeys(mapping, posData))
      XLSX.utils.book_append_sheet(wb, posDataWS, t('message.position'))
      XLSX.writeFile(wb, 'company_tree.xlsx')
    }
    catch (error) {
      if(error.status == 403)
        utils.movePage('/login')
      else {
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  }
  else {
    let excelData = JSON.parse(JSON.stringify(items.value))
    if (type == 'check') {
      excelData = JSON.parse(JSON.stringify(selected.value))
    }
    if (excelData.length == 0) {
      snackText.value = t('message.noDataSelected')
      snackbar.value = true
      return
    }

    const dataWS = XLSX.utils.json_to_sheet(utils.renameKeys(mapping, excelData))
    //const dataWS = XLSX.utils.json_to_sheet(excelData)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, dataWS, 'Sheet1')
    XLSX.writeFile(wb, 'member_list.xlsx')
  }
}

const excelUpload=async()=>{
  snackText.value = ''
  const fileInfo = excelFile.value.files[0];
  let reader = new FileReader()
  reader.readAsArrayBuffer(fileInfo)
  reader.onload = async()=> {
    const fileData = reader.result
    const wb = XLSX.read(fileData, { type: "binary" })
    let toJson:any = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
    toJson = utils.renameKeys(mappingReverse.value, toJson)
    //업로드
    const memberList = [];
    for (const [key, item] of toJson.entries()) {
      if(!utils.isEmpty(item.memberId)) {
        let params = {
          companyIdx: localStorage.getItem('companyIdx'),
          memberId: item.memberId,
          password: item.password,
          memberName: item.memberName,
          deptIdx: item.deptIdx,
          posIdx: item.posIdx,
          deptName: item.deptName,
          posName: item.posName,
          telNo: item.telNo,
          email: item.email,
          useYn: item.useYn,
          adminYn: item.adminYn,
          headYn: item.headYn,
          shiftYn: item.shiftYn,
          shiftName: item.shift,
          passwordYn: item.passwordYn,
          clientIdx: localStorage.getItem('clientIdx')
        }
        memberList.push(params)
      }
    }

    if(memberList.length > 0) {
      isLoading.value = true
      try {
        const response = await MemberService.insertMemberList({memberList:memberList})
        isLoading.value = false
        if (response.success){
          snackbar.value = true
          snackText.value = `${t('message.uploadSuccess')} : ${response.result.successCnt} \n ${t('message.uploadFail')} : ${response.result.failCnt} \n ${response.result.failReason}`
          onClickSearch('')
        }
      }
      catch(error){
        isLoading.value = false
        if (error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    }

    excelFile.value.value = ''
  }
}

/** 엑셀 다운로드 시 rename될 mapping 양식 */
const mapping = {
  idx:t('message.code'),
  memberId:t('message.id'),
  memberName:t('message.name'),
  deptName:t('message.department'),
  posName:t('message.position'),
  telNo:t('message.phoneNumber'),
  email:t('message.email'),
  useYn:t('message.isActive'),
  adminYn:t('message.isAdmin'),
  headYn:t('message.isOrgLeader'),
  shiftYn:t('message.isShiftWorker'),
  shift:t('message.shiftWork'),
  passwordYn:t('message.isPasswordRequired'),
  regDate:t('message.registrationDate'),
  treeName:t('message.codeName')
}

const mappingReverse = computed(() => ({
  [t('message.id')]:'memberId',
  [t('message.password')]:'password',
  [t('message.name')]:'memberName',
  [t('message.department')]:'deptName',
  [t('message.position')]:'posName',
  [t('message.phoneNumber')]:'telNo',
  [t('message.email')]:'email',
  [t('message.isActive')]:'useYn',
  [t('message.isAdmin')]:'adminYn',
  [t('message.isOrgLeader')]:'headYn',
  [t('message.isShiftWorker')]:'shiftYn',
  [t('message.shiftWork')]:'shift',
  [t('message.isPasswordRequired')]:'passwordYn',
}))

</script>

